import * as types from './constants';

// Get Refer Connections
export const getReferralsConnectionsRequest = data => (
  { type: types.GET_REFERRALS_CONNECTIONS_REQUEST, payload: data }
);

export const getReferralsConnectionsDone = data => (
  { type: types.GET_REFERRALS_CONNECTIONS_DONE, payload: data }
);

export const getReferralsConnectionsFailed = errors => (
  { type: types.GET_REFERRALS_CONNECTIONS_FAILED, payload: errors }
);

// Operations
export const referralsConnectionsSetPage = data => (
  { type: types.REFERRALS_CONNECTIONS_SET_PAGE, payload: data }
);